import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { PaginateListMore } from 'src/app/common/types/common-types';
import { useDataProvider } from 'src/app/common/utils';
import PromotionImageList from './components/PromotionImageList';
import { PromotionImageItem, PromotionImageListParams } from '../../types/promotion-image-type';
import { fetchList } from '../../network/promotion-image-network';

type PromotionImageListingPageProps = {} & ParamsProps;
export const filterKeys = ['name', 'updatedTime'];

const initialState: PromotionImageListParams = {
  name: '',
  page: 1,
  limit: 5,
};

const paramsInitiator = (initialParams?: Record<string, string>): PromotionImageListParams => {
  return initialParams
    ? {
        name: initialParams.name ? initialParams.name : '',
        page: 1,
        limit: 5,
      }
    : initialState;
};

const PromotionImageListingPage: FC<PromotionImageListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const dispatch = useDispatch();

  const [filterState, setFilterState] = useState<PromotionImageListParams>(paramsInitiator(initialParams));
  const [itemList, setItemList] = useState<PaginateListMore<PromotionImageItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateListMore<PromotionImageItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchList(filterState, dispatch);
      } catch (err) {}
    },
    setItemList,
    false,
  );

  return (
    <>
      <PruFilter
        title={Translation('title.resource.bdm.promotion') + ' Filter'}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'name',
            initialValue: filterState.name,
            displayName: Translation('title.resource.bdm.promotion') + ' ' + Translation('component.formLabel.name'),
            maxLength: 30,
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            name: data.name,
          })
        }
        fetchData={refreshData}
      />
      <PromotionImageList
        isLoading={isLoading}
        onRefresh={refreshData}
        itemList={itemList}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default PromotionImageListingPage;
